import { PromptModelWorkflow } from '~/api/sylvanus/typedefs.autogen';
import { sylvanus } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

interface Request {
  modelId: Uuid;
}

type Response = boolean;

export const suspendPromptModel = async ({
  modelId,
}: Request): Promise<Response> => {
  const response = (await sylvanus.patch(
    `/model/${modelId}/suspend`,
  )) as PromptModelWorkflow;

  return Boolean(response);
};
